import { render, staticRenderFns } from "./PolicyCardWrapper.vue?vue&type=template&id=2fa0ad15&scoped=true&lang=pug&"
import script from "./PolicyCardWrapper.vue?vue&type=script&lang=js&"
export * from "./PolicyCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCardWrapper.vue?vue&type=style&index=0&id=2fa0ad15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0ad15",
  null
  
)

export default component.exports